import {
    forwardRef,
    ReactNode,
    SelectHTMLAttributes,
    useEffect,
    useImperativeHandle,
    useRef,
} from "react";

export default forwardRef(function SelectInputWithIcon(
    {
        className = "",
        isFocused = false,
        icon,
        error,
        disabled,
        ...props
    }: SelectHTMLAttributes<HTMLSelectElement> & {
        isFocused?: boolean;
        icon?: ReactNode;
        error?: string;
    },
    ref,
) {
    const localRef = useRef<HTMLSelectElement>(null);
    useImperativeHandle(ref, () => ({
        focus: () => localRef.current?.focus(),
    }));

    useEffect(() => {
        if (isFocused) {
            localRef.current?.focus();
        }
    }, [isFocused]);

    const disabledClass = "opacity-50 cursor-not-allowed ";
    const errorClasses = " border border-red-700 ";

    return (
        <div className={`relative inline-flex w-full`}>
            {icon && (
                <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    {icon}
                </div>
            )}
            <select
                {...props}
                disabled={disabled}
                className={
                    (disabled ? disabledClass : "") +
                    "rounded-md border-gray-300 shadow-sm focus:border-neutral4 focus:ring-neutral4 ring-neutral4 pl-10 " +
                    className +
                    (error !== undefined ? errorClasses : "")
                }
                ref={localRef}
            />
        </div>
    );
});
